import React, {
    Component,
} from 'react';

export default class SplitTabsView extends Component {
    render() {
        const {
            isPrint,
            selectedIndex,
            tabs,
            setSelectedIndex,
            leftChildren,
            rightChildren,
        } = this.props;
        return <div className={`NewFinancialPlan_Insurance_SplitTabs${tabs.length > 0 && !isPrint ? " multiple": ""}`}>
            <section className="left-container">{leftChildren}</section>
            <section className="right-container">
                {rightChildren}
                {!isPrint && <ul>
                    {
                        tabs.map(
                            (tab, index) => {
                                if (index === selectedIndex) {
                                    return <li className="selected">{tabs[index]}</li>;
                                }
                                return <li onClick={setSelectedIndex(index)}>{tabs[index]}</li>;
                            }
                        )
                    }
                </ul>}
            </section>
        </div>;
    }
};